var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowRight = function SvgArrowRight(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5304 3.96955C12.2375 3.67665 11.7626 3.67665 11.4697 3.96955C11.1768 4.26244 11.1768 4.73731 11.4697 5.03021L17.6894 11.2499H4.50006C4.08585 11.2499 3.75006 11.5857 3.75006 11.9999C3.75006 12.4141 4.08585 12.7499 4.50006 12.7499H17.6894L11.4697 18.9695C11.1768 19.2624 11.1768 19.7373 11.4697 20.0302C11.7626 20.3231 12.2375 20.3231 12.5304 20.0302L20.5607 11.9999L12.5304 3.96955Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5304 3.96955C12.2375 3.67665 11.7626 3.67665 11.4697 3.96955C11.1768 4.26244 11.1768 4.73731 11.4697 5.03021L17.6894 11.2499H4.50006C4.08585 11.2499 3.75006 11.5857 3.75006 11.9999C3.75006 12.4141 4.08585 12.7499 4.50006 12.7499H17.6894L11.4697 18.9695C11.1768 19.2624 11.1768 19.7373 11.4697 20.0302C11.7626 20.3231 12.2375 20.3231 12.5304 20.0302L20.5607 11.9999L12.5304 3.96955Z",
    fill: "currentColor",
    fillOpacity: 0.2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "arrow-right.6e8ede82656fe5847be89fbc0d52c23d.svg";